import React from 'react';
import { MovedPartially } from '../../../../../types';

const Dummy: React.FC<MovedPartially> = props => {
    return (
        <div>
            {props.eventType}
        </div>
    );
};

export default Dummy;
